/* eslint-disable jsx-a11y/anchor-is-valid */
import { useSelector, useDispatch } from "react-redux";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import GoogleLogin from "react-google-login";

import { handleApiErrors } from "../../../utils/handleErrors";
import t from "../../../i18n/i18n";
import useApi from "../../../services/api";
import { UpdateUser } from "../../../store/reducers/auth.reducer";

import Notify from "../../../components/notification/notify";

function SocialForm() {
  const {
    user: { facebook_id, google_id, withOutPassword },
  } = useSelector((store) => store.auth);

  const dispatch = useDispatch();

  const { ApiUpdateUser } = useApi();

  async function SubmitFacebook({ userID }) {
    if (!userID) return;

    const { data } = await ApiUpdateUser({ facebook_id: userID });

    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    dispatch(UpdateUser(data));

    return Notify({ type: "success", message: t("Success.AddedFacebookLogin") });
  }

  async function SubmitGoogle({ googleId }) {
    if (!googleId) return;

    const { data } = await ApiUpdateUser({ google_id: googleId });

    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    dispatch(UpdateUser(data));

    return Notify({ type: "success", message: t("Success.AddedGoogleLogin") });
  }

  async function removeSocialLogin(network) {
    if (withOutPassword) {
      return Notify({ type: "danger", message: t("Errors.AddAPasswordFirst") });
    }

    if (network === "facebook") {
      const { data } = await ApiUpdateUser({ facebook_id: "" });
      dispatch(UpdateUser(data));
      return Notify({ type: "success", message: t("Success.RemovedFacebookLogin") });
    }

    if (network === "google") {
      const { data } = await ApiUpdateUser({ google_id: "" });
      dispatch(UpdateUser(data));
      return Notify({ type: "success", message: t("Success.RemovedGoogleLogin") });
    }
  }

  return (
    <div className="form-col profile-form ">
      <h1 className="text-uppercase">{t("Profile.LoginSocialTitle")}</h1>
      <ul className="social-login-list">
        {!facebook_id && (
          <li>
            <FacebookLogin
              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
              fields="name,email,picture"
              callback={SubmitFacebook}
              render={(renderProps) => (
                <div className="facebook-login">
                  <a href="#" className="" onClick={renderProps.onClick}>
                    <i className="icon fab fa-facebook-f"></i> {t("Profile.Form.LoginFacebook")}
                  </a>
                </div>
              )}
            />
          </li>
        )}
        {facebook_id && (
          <li>
            <div className="facebook-login">
              <a href="#" className="" onClick={() => removeSocialLogin("facebook")}>
                <i className="icon fab fa-facebook-f"></i> {t("Profile.Form.RemoveFacebook")}
              </a>
            </div>
          </li>
        )}
        {!google_id && (
          <li>
            <GoogleLogin
              clientId={process.env.REACT_APP_GOOGLE_APP_ID}
              render={(renderProps) => (
                <div className="google-login">
                  <a href="#" className="" onClick={renderProps.onClick} disabled={renderProps.disabled}>
                    <i className="icon">
                      <img src="/images/google-m.png" alt="" />
                    </i>
                    {t("Profile.Form.LoginGoogle")}
                  </a>
                </div>
              )}
              buttonText="Login"
              onSuccess={SubmitGoogle}
              onFailure={(e) => console.log(e)}
              cookiePolicy={"single_host_origin"}
            />
          </li>
        )}
        {google_id && (
          <li>
            <div className="google-login">
              <a href="#" className="" onClick={() => removeSocialLogin("google")}>
                <i className="icon">
                  <img src="/images/google-m.png" alt="" />
                </i>
                {t("Profile.Form.RemoveGoogle")}
              </a>
            </div>
          </li>
        )}
      </ul>
    </div>
  );
}

export default SocialForm;
